import './utils/polyfill';

import * as Sentry from '@sentry/react';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initSentry } from './analytics/init-sentry';
import './assets/styles/global.css';
import './assets/styles/style.scss';
import App from './components/App';
import { getConfig } from './config';

initSentry();

const rootElement = document.getElementById('root');
if (rootElement == null) {
  throw new Error('rootElement cannot be null');
}
const root = createRoot(rootElement);

const render = async () => {
  const config = await getConfig();

  const LDProvider = await asyncWithLDProvider({
    clientSideID: config.launchDarklyClientId,
    options: {
      streaming: location.hostname === 'localhost',
      logger: {
        debug() {},
        info() {},
        warn(...args) {
          console.warn(...args);
        },
        error(...args) {
          console.error(...args);
        },
      },
    },
    context: {
      kind: 'user',
      anonymous: true,
      webApp: 'bestill.rikstv.no',
    },
    timeout: 3,
  });

  root.render(
    <LDProvider>
      <Sentry.ErrorBoundary fallback={<p>Noe gikk galt</p>}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Sentry.ErrorBoundary>
    </LDProvider>,
  );
};

render();
